module.exports = __webpack_public_path__ + "dist/media/ec_comp_pagination.259b14bb.svg";